module.exports = __webpack_public_path__ + "static/media/01-03.7d681833.mp3";